import { useEffect, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useApi } from "@/lib/api";

export default function ReportDialog({ gradeKey = "boerse", label = "Report-Vorschau", testId = "btn-report-preview" }) {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    if (!open) return;
    setHtml(null);
    api.get("/report", { params: { grade_key: gradeKey } }).then((r) => setHtml(r.data.html)).catch(() => setHtml("<p>Report nicht verfügbar</p>"));
  }, [open, api, gradeKey]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary" size="sm" data-testid={testId}>
          <FileText className="mr-2 h-4 w-4" /> {label}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl border-slate-200 bg-white" data-testid="modal-entwicklungsreport-preview">
        <DialogHeader>
          <DialogTitle>Entwicklungsreport – so sieht die E-Mail aus</DialogTitle>
        </DialogHeader>
        <div className="h-[65vh] overflow-hidden rounded-lg bg-white">
          {html ? (
            <iframe title="Report" sandbox="" srcDoc={html} style={{ background: "#fff" }} className="h-full w-full" data-testid="report-iframe" />
          ) : (
            <div className="flex h-full items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-orange-600" /></div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
